import axios from "axios";

// Se configura en .env.development / .env.production (VUE_APP_API_URL)
const baseURL =
  process.env.VUE_APP_API_URL ||
  (process.env.NODE_ENV === "production"
    ? "https://santodomingocartagena.com/api"
    : "http://localhost/api_santodomingo/public/api");

const axiosInstance = axios.create({
  baseURL,
  headers: {
    Accept: "application/json",
  },
  timeout: 15000,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token_parmada");

    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Motivo por el que se ha expulsado al usuario; el login lo muestra y lo borra.
export const MOTIVO_LOGIN_KEY = "motivo_login";

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response && error.response.status;
    const code = error.response && error.response.data && error.response.data.code;

    if (status === 401) {
      const teniaSesion = Boolean(sessionStorage.getItem("token_parmada"));
      sessionStorage.removeItem("token_parmada");

      if (teniaSesion) {
        sessionStorage.setItem(MOTIVO_LOGIN_KEY, code === "account_locked" ? "bloqueada" : "caducada");
      }

      if (window.location.pathname !== "/login") {
        window.location.assign("/login");
      }
    } else if (status === 403 && code === "password_change_required") {
      // El panel abre el cambio de contraseña obligatorio.
      window.dispatchEvent(new CustomEvent("sd:password-requerida"));
    } else if (status === 403 && code === "forbidden") {
      // Puede que le hayan cambiado el rol: el panel recarga sus permisos.
      window.dispatchEvent(new CustomEvent("sd:sin-permiso"));
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
